import { i18n } from '@fs/zion-locale'

export default {
  wikiPageSubTitle: () => i18n.t('references.research-wiki.subTitle', 'Wiki Page'),
  noWikiPages: () =>
    i18n.t(
      'references.image-group-does-not-belong-to-any-wikis.description',
      'There are no wiki pages that returned for this image group.'
    ),
  noCollections: () =>
    i18n.t(
      'references.image-group-does-not-belong-to-the-any-collections.description',
      'This image group does not belong to any collections.'
    ),
  errorGettingWikis: () =>
    i18n.t('references.error-getting-wikis.message', 'There was an error getting the wikis for this group.'),
  catalogCollection: () => i18n.t('references.catalog-collection.subTitle', 'Catalog Collection'),
  historicalRecordCollection: () =>
    i18n.t('references.historical-record-collection.subTitle', 'Historical Record Collection'),
  errorGettingCollectionGroup: () =>
    i18n.t(
      'references.error-getting-parent-collection.message',
      'There was an error getting the collection this group belongs to.'
    ),
  errorGettingCollectionTitle: () =>
    i18n.t('references.error-getting-collection-title.message', 'There was an error getting the collection title.'),
  autoCollection: () => i18n.t('references.auto-collection.subTitle', 'Auto Collection'),
  references: () => i18n.t('references.references.title', 'References'),
  collections: () => i18n.t('references.collections.title', 'Collections'),
  partOfCollections: () =>
    i18n.t(
      'references.image-group-belongs-to-the-following-collections.description',
      'This image group is part of the following collections:'
    ),
  researchWiki: () => i18n.t('references.research-wiki.title', 'Research Wiki'),
  researchArticles: () =>
    i18n.t(
      'references.image-group-belongs-to-the-following-research-articles.description',
      'These research articles may provide additional context for your search:'
    ),
}
